import React, {useContext} from 'react';
import {RuleDialogComponent} from './RuleDialog.component';
import {AutomationContext} from '../../context';
import {RuleType} from '../../enums';

type Props = {
    type: RuleType;
    isOpen: boolean;
    showValidForOptions?: boolean;
    title: string;
    subtitle?: string | React.ReactNode;
    specialCondition?: React.ReactElement;
    help?: string;
    session: string;
    currentFormTitle?: string;
};

export const RuleDialog = (props: Props) => {
    const {aiGeneratedRuleId} = useContext(AutomationContext);

    if (!props.isOpen) return null;

    /*
     * we use aiGeneratedRuleId as key to force re-rendering of the dialog when
     * the AI rule is generated by the new query
     */
    return <RuleDialogComponent key={aiGeneratedRuleId} {...props} />;
};
